import { PopoverBody, PopoverFooter, PopoverHeader } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import {
  ExperienceDetailResource,
  ExperienceResource,
} from '../../../../CurrentCollectionStep/BuilderV2/Types';
import {
  ExperienceAction,
  ExperienceAvailableLanguages,
  ExperienceCompetency,
  ExperienceDescription,
  ExperienceTimeCommitment,
  ExperienceTitle,
  ExperienceUpcomingDates,
} from './Components';

export interface Props {
  experienceResource: ExperienceResource;
  experienceDetailResource: ExperienceDetailResource;
}

function Popover({ experienceResource, experienceDetailResource }: Props) {
  return (
    <div data-intercom-target="learning-collection-experience-popover">
      <PopoverHeader className="flex flex-col gap-y-3">
        <ExperienceTitle title={experienceResource.payload.title} />
      </PopoverHeader>
      <PopoverBody className="-ml-2 max-h-[26.25rem] gap-y-4 pb-1 pl-2">
        <ExperienceTimeCommitment
          experienceDetailResource={experienceDetailResource}
          experienceResource={experienceResource}
        />
        <ExperienceAvailableLanguages languages={experienceDetailResource.payload.languages} />
        <ExperienceDescription experienceDetailResource={experienceDetailResource} />
        <ExperienceCompetency experienceResource={experienceResource} />
        <ExperienceUpcomingDates experienceDetailResource={experienceDetailResource} />
      </PopoverBody>
      <PopoverFooter className="gap-y-2 empty:hidden">
        <ExperienceAction />
      </PopoverFooter>
    </div>
  );
}

export default observer(Popover);
